const sticky = document.querySelector('.js-stickyCTA');

function close() {
  sticky.classList.add('stickyCTA--hidden');
  sessionStorage.setItem('closedStickyCTA', true);
}

function init() {
  if (sticky) {
    const closeBtn = sticky.querySelector('.js-stickyCTA__close');

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }
  }
}

export { init };
